import $ from 'jquery';

import * as net from 'util/Net';
import {HTTPHeaders} from 'util/Net';

export default function patchJSONString({
  url,
  data,
  extraHeaders,
}: {
  url: string;
  data: string;
  extraHeaders?: HTTPHeaders;
}): Promise<unknown> {
  return Promise.resolve(
    $.ajax({
      contentType: 'application/json',
      type: 'PATCH',
      url,
      data,
      dataType: 'json',
      headers: {...net.getPOSTHeaders(), ...extraHeaders},
    }) as unknown
  );
}
